export default "__VITE_ASSET___UAwWe2u__"